import React from "react";
import styled from "styled-components";

type TextProps = {
  fontweight?: string;
  fontsize?: string;
  margin?: string;
};

const MessageContainer = styled.div`
  margin: 40px 0 0 0;
`;

const StyledText = styled.p<TextProps>`
  color: black;
  font-size: ${(props) => (props.fontsize ? props.fontsize : "15px")};
  font-weight: ${(props) => (props.fontweight ? props.fontweight : "400")};
  margin: ${(props) => (props.margin ? props.margin : "0")};
`;

export default function DisplayMessage() {
  return (
    <MessageContainer>
      <StyledText margin={"0 0 3px 0"} fontweight={"700"} fontsize={"20px"}>
        들어온 요청
      </StyledText>
      <StyledText fontsize={"16px"}>
        파트너님에게 딱 맞는 요청서를 찾아보세요.
      </StyledText>
    </MessageContainer>
  );
}
